// extracted by mini-css-extract-plugin
export var container = "_d9-0";
export var icon = "_d9-1";
export var text = "_d9-2";